import Css from "./style.module.scss";

import * as Icons from "@phosphor-icons/react";
import { Badge } from "nlib/ui";
import { getCurrentQuickBooksRealmId } from "selectors/businesses";
import { useSelector } from "react-redux";
import AdvancedTransactionTypes from "const/AdvancedTransactionTypes";
import Constants from "const/Constants";
import DataStatuses from "const/DataStatuses";
import DocumentTypes from "const/DocumentTypes";
import React, { useCallback } from "react";

const TransactionsCell = ({ documentData, onPairTransactionsLinkClick }) => {
  const quickBooksBusiness = useSelector(getCurrentQuickBooksRealmId);

  const {
    id,
    type,
    status,
    matchedTransactions = 0,
    paidTransactions = [],
    exportAs = quickBooksBusiness && type === DocumentTypes.RECEIPT ? AdvancedTransactionTypes.EXPENSE : undefined
  } = documentData;

  const extractStatus = status === DataStatuses.TO_EXTRACT;

  const pairedTransactionsCount = paidTransactions.length;

  const handlePairTransactionsLinkClick = useCallback(() => {
    onPairTransactionsLinkClick(id);
  }, [id, onPairTransactionsLinkClick]);

  if (extractStatus) return Constants.EMPTY_PLACEHOLDER;

  return (
    <a
      disabled={type === DocumentTypes.RECEIPT && exportAs === AdvancedTransactionTypes.EXPENSE}
      title={pairedTransactionsCount}
      className={Css.transactionsCell}
      onClick={handlePairTransactionsLinkClick}>
      <Icons.CreditCard />
      <Badge
        counter inverted
        theme={pairedTransactionsCount ? "primary" : (matchedTransactions ? "alternative" : "")}>
        {pairedTransactionsCount || (matchedTransactions && `${matchedTransactions}?`)}
      </Badge>
    </a>
  );
};

export default React.memo(TransactionsCell);
